import { IBurnsAction, IBurnsState } from './burns.types'
import { BurnsConstants } from './burns.constants'

export const initialBurnsSummaryState = {
  headAnterior: 0,
  headPosterior: 0,
  armsAnterior: 0,
  armsPosterior: 0,
  trunkAnterior: 0,
  trunkPosterior: 0,
  legsAnterior: 0,
  legsPosterior: 0,
  firstDegree: 0,
  secondDegree: 0,
  thirdDegree: 0,
  tbsaScore: 0,
}

export const initialBurnsTbsaState = {
  isTBSA: 1,
}

export const initialAdditionalBurnInformation = {
  burnType: null,
  singedNasalHair: 0,
  carbonInMouth: 0,
  poorVentilation: 0,
  coLevel: '',
}

const initialBurnsRO9State = {
  AdultFHead: 0,
  AdultFLegR: 0,
  AdultFLegL: 0,
  AdultFChestLung: 0,
  AdultFGenitalia: 0,
  AdultFArmR: 0,
  AdultFArmL: 0,
  AdultFPelvis: 0,
  AdultBLegL: 0,
  AdultBLegR: 0,
  AdultBHead: 0,
  AdultBBack: 0,
  AdultBArmL: 0,
  AdultBArmR: 0,
  AdultBPelvis: 0,
}

export const initialBurnsState: IBurnsState = {
  ...initialBurnsTbsaState,
  burnsExamData: [],
  bodyView: {
    id: 1,
    name: 'Front',
  },
  ...initialBurnsSummaryState,
  additionalBurnInformation: initialAdditionalBurnInformation,
  burnsColorData: { ...initialBurnsRO9State },
  __currentSelectedObj: null,
  __range: 0,
}

export function burnsReducer(state: IBurnsState = initialBurnsState, action: IBurnsAction): IBurnsState {
  switch (action.type) {
    case BurnsConstants.SET_SELECTED_BURN_TYPE:
      return { ...state, isTBSA: action.isTBSA }
    case BurnsConstants.SET_COLOR_STATE:
      return { ...state, burnsColorData: action.burnsColorData }
    case BurnsConstants.SET_BURNS_EXAM:
      return { ...state, burnsExamData: action.burnsExamData }
    case BurnsConstants.SET_BODY_VIEW:
      return { ...state, bodyView: action.bodyView }
    case BurnsConstants.SET_TOTAL_BURNS_CALCULATIONS:
      return { ...state, ...action.totalBurnsCalculations }
    case BurnsConstants.SET_BURN_TYPE:
      return { ...state, additionalBurnInformation: { ...state.additionalBurnInformation, burnType: action.burnType } }
    case BurnsConstants.SET_SINGED_NASAL_HAIR:
      return {
        ...state,
        additionalBurnInformation: { ...state.additionalBurnInformation, singedNasalHair: action.singedNasalHair },
      }
    case BurnsConstants.SET_CARBON_IN_MOUTH:
      return {
        ...state,
        additionalBurnInformation: { ...state.additionalBurnInformation, carbonInMouth: action.carbonInMouth },
      }
    case BurnsConstants.SET_POOR_VENTILATION:
      return {
        ...state,
        additionalBurnInformation: { ...state.additionalBurnInformation, poorVentilation: action.poorVentilation },
      }
    case BurnsConstants.SET_CO_LEVEL:
      return { ...state, additionalBurnInformation: { ...state.additionalBurnInformation, coLevel: action.coLevel } }
    case BurnsConstants.SET_CURRENT_SELECTED_OBJ:
      return {
        ...state,
        __currentSelectedObj: action.__currentSelectedObj,
      }
    case BurnsConstants.SET_RANGE:
      return {
        ...state,
        __range: action.__range,
      }
    case BurnsConstants.SET_BURNS:
      return { ...action.burns }
    case BurnsConstants.RESET_BURNS_TBSA:
      return { ...initialBurnsState, additionalBurnInformation: state.additionalBurnInformation }
    case BurnsConstants.RESET_BURNS:
      return { ...initialBurnsState }
    default:
      return state
  }
}
